import {Button} from 'antd';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {EMetaActionType} from 'entities/metadata';
import {requestSliceActions} from 'store/slices/request-slice/request-slice';

interface IButtonSendToAgreementProps {
    actionTitle: string;
    actionType: EMetaActionType;
}
export const ButtonSendToAgreement: FC<IButtonSendToAgreementProps> = ({
    actionTitle = 'Сохранить',
    actionType,
    ...props
}: IButtonSendToAgreementProps) => {
    const dispatch = useDispatch();
    const {setSubmitButtonActionType} = requestSliceActions;

    return (
        <Button
            {...props}
            type="primary"
            className="save-action-btn"
            onClick={() => dispatch(setSubmitButtonActionType(actionType))}
            htmlType="submit"
        >{actionTitle}
        </Button>
    );
};
